import { columns } from '@/components/deals/deal';
<template>
  <div style="margin: 4">
    <div flex flex-row items-center justify-between mb-4>
      <h2 class="text-2xl font-bold">
        Tipos de Solicitudes y Configuraciones de SLA
      </h2>
    </div>
    <el-alert
      v-if="!IsInRoles([roles.CEO, roles.SuperUsuario, roles.GerenteRRHH])"
      title="Lo sentimos, Usted no tiene acceso a este módulo"
      type="warning"
    ></el-alert>
    <div v-if="IsInRoles([roles.CEO, roles.SuperUsuario, roles.GerenteRRHH])">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="18">
          <el-row :gutter="10" type="flex" class="row-bg" justify="start">
            <el-col :span="5">
              <el-select
                size="mini"
                v-model="serviceTypeId"
                placeholder="Selección tipo de solicitud"
                filterable
                ref="serviceTypeFilter"
                style="width: 100%"
                clearable
                @change="onServiceTypeChange"
                :disabled="selectionsDisable"
                :loading="loadingServiceRequestTypes"
              >
                <el-option
                  v-for="(serv, index) in serviceTypeList"
                  :key="index"
                  :value="serv.Id"
                  :label="serv.Description"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <DirectionSelector
                size="mini"
                :initialDirection="filters.Direction"
                @selection-change="handleDirectionChange"
              />
            </el-col>
            <el-col :span="3">
              <DepartmentsComponent
                :initialDirection="filters.Direction"
                :initialDeparment="filters.Departmet"
                :DirecctionID="filters.Direction"
                fieldSize="mini"
                @selectionChange="handleDepartmentChange"
              />
            </el-col>
            <el-col :span="3">
              <EmployeeSelector
                :DireccionParams="filters.Direction"
                :DeparmentParams="filters.Departmet"
                :CurrentEmployee="filters.Employee"
                placeholder="Responsable"
                @selection-change="handleEmployeeChange"
              />
            </el-col>
            <el-col :span="4">
              <positions-selector @posicionChange="onPosicionChange" />
            </el-col>
          </el-row>
        </el-col>

        <el-button
          size="mini"
          v-if="editarMultipleVisivility"
          type="primary"
          @click="OnEditarClicked"
          >Editar</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="OnCreateClicked"
          icon="el-icon-plus"
          >Nuevo</el-button
        >
      </el-row>
      <div>
        <rabbey-table-3
          strip
          :columns="columns"
          :data="filteredData"
          :actions="actions"
          :loading="loading"
          @selection-change="onRowSelected"
          @current-change="onCurrentChange"
          @rtable-push-action="handleActionComand"
        />
      </div>
      <edit-service-request-type-form
        :isEdit="isEdit"
        :dialogFormVisible="viewEditForm"
        :ServiceRequestTypeRow="actualRow"
        @closeDialog="viewEditForm = false"
        @update-table="getData"
      />
    </div>
  </div>
</template>

<script>
import ServiceRequestTypesAndSla, {
  ActionsRquestsTypes
} from "@/columns/ServiceRequestTypesAndSla";
import EditServiceRequestTypeForm from "@/components/requests/serviceRequestType/EditServiceRequestTypeForm.vue";
import DirectionSelector from "@/components/Company/DirectionSelector";
import DepartmentsComponent from "@/components/Company/DepartmentsComponent";
import EmployeeSelector from "@/components/Company/EmployeeSelector";
import PositionsSelector from "@/components/Employees/PositionsSelector.vue";

export default {
  name: "ServiceRequestTypesAndSLAConfigurations",
  components: {
    EditServiceRequestTypeForm,
    DirectionSelector,
    DepartmentsComponent,
    EmployeeSelector,
    PositionsSelector
  },
  data() {
    return {
      columns: ServiceRequestTypesAndSla,
      data: [],
      actions: ActionsRquestsTypes,
      loading: false,
      editarMultipleVisivility: false,
      viewEditForm: false,
      actualRow: {},
      isEdit: false,
      serviceTypeId: "",
      serviceTypeList: [],
      filters: {
        Direction: 0,
        Departmet: 0,
        Employee: 0,
        Posicion: 0
      },
      loadingServiceRequestTypes: false
    };
  },
  async mounted() {
    await this.getData();
    await this.getServicesTypes();
  },
  computed: {
    filteredData() {
      // return this.serviceTypeId !== ""
      //   ? this.data.filter((d) => d.Id === this.serviceTypeId)
      //   : this.data;
      return this.data;
    }
  },
  methods: {
    async getData() {
      this.loading = true;

      const body = {
        params: {
          Id: this.serviceTypeId,
          DirectionId: this.filters.Direction,
          DeparmentId: this.filters.Departmet,
          responsableId: this.filters.Employee,
          PositionId: this.filters.Posicion
        }
      };

      await this.$http
        .get("/api/serviceRequestTypes/GetServiceRequesTypesWithSla", body)
        .then((res) => {
          this.data = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleActionComand(action) {
      switch (action.command) {
        case "edit-request-type":
          this.actualRow = action.row;
          this.OnEditarClicked();
          break;
      }
    },
    onRowSelected(rows) {
      if (rows.length > 0) {
        this.editarMultipleVisivility = true;
      } else {
        this.editarMultipleVisivility = false;
      }
    },
    onCurrentChange() {},
    OnEditarClicked() {
      this.viewEditForm = true;
      this.isEdit = true;
    },
    OnCreateClicked() {
      this.actualRow = {
        Description: "",
        DaysToRespond: "",
        Direction: "",
        Departmet: "",
        Employee: "",
        Estatus: ""
        // delivery: false,
        // type: [],
        // resource: "",
        // desc: "",
      };
      this.viewEditForm = true;
      this.isEdit = false;
    },
    async getServicesTypes(criterial) {
      this.loadingServiceRequestTypes = true;
      await this.$http
        .get("/api/serviceRequestTypes/GetServiceByCompany", {
          params: {
            direccionID: criterial != undefined ? criterial : 0
          }
        })
        .then((resp) => {
          this.serviceTypeList = resp.data.filter(
            (f) => f.IsInternal !== null && f.IsInternal
          );
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          this.loadingServiceRequestTypes = false;

          if (this.ResquestObject.ResquestTypeId != 0) {
            //this.objRules.serviceTypeList.Id = this.ResquestObject.ResquestTypeId
          }
        });
    },
    async handleDirectionChange(value) {
      this.filters.Direction = value;
      await this.getData();
    },
    async handleDepartmentChange(value) {
      this.filters.Departmet = value;
      await this.getData();
    },
    async handleEmployeeChange(value) {
      this.filters.Employee = value;
      await this.getData();
    },
    async onPosicionChange(value) {
      this.filters.Posicion = value;
      await this.getData();
    },
    async onServiceTypeChange() {
      await this.getData();
    }
  }
};
</script>

<style lang="scss" scoped></style>
